import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  getUnapprovedGroupNotification(): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/unapprovedGroupNotification`).pipe(map((response) => response.result));
  }

  getUnapprovedNewsNotification(): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/unapprovedNewsNotification`).pipe(map((response) => response.result));
  }

  getUnapprovedFaqNotification(): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/unapprovedFaqNotification`).pipe(map((response) => response.result));
  }

  getUnapprovedInstructorNotification(): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/unapprovedInstructorNotification`).pipe(map((response) => response.result));
  }

  getUnapprovedRoomsNotification(): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/unapprovedRoomsNotification`).pipe(map((response) => response.result));
  }

  getUnapprovedEventNotification(): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/unapprovedEventNotification`).pipe(map((response) => response.result));
  }

  getUnapprovedSurveysNotifications(): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/unapprovedSurveyNotification`).pipe(map((response) => response.result));
  }

  getUnapprovedCoursesNotifications(): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/unapprovedCourseNotification`).pipe(map((response) => response.result));
  }

  getUnapprovedTasksNotifications(): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/unapprovedTaskNotification`).pipe(map((response) => response.result));
  }

  // ----------others Roles--------

  getAllNewsUsersNotifications() {
    return this._http.get<any>(`${this._apiUrl}/newsNotificationForUser`).pipe(map((response) => response.result));
  }

  getAllFAQsUsersNotifications() {
    return this._http.get<any>(`${this._apiUrl}/faqNotificationForUser`).pipe(map((response) => response.result));
  }

  getAllRoomsUsersNotifications() {
    return this._http.get<any>(`${this._apiUrl}/roomsNotificationForUser`).pipe(map((response) => response.result));
  }

  getAllGroupsUsersNotifications() {
    return this._http.get<any>(`${this._apiUrl}/groupNotificationForUser`).pipe(map((response) => response.result));
  }

  getAllInstructorsUsersNotifications() {
    return this._http.get<any>(`${this._apiUrl}/instructorNotificationForUser`).pipe(map((response) => response.result));
  }

  getAllEventsUsersNotifications() {
    return this._http.get<any>(`${this._apiUrl}/eventNotificationForUser`).pipe(map((response) => response.result));
  }

  getAllSurveysUsersNotifications() {
    return this._http.get<any>(`${this._apiUrl}/surveyNotificationForUser`).pipe(map((response) => response.result));
  }

  getAllCoursesUsersNotifications() {
    return this._http.get<any>(`${this._apiUrl}/courseNotificationForUser`).pipe(map((response) => response.result));
  }

  getAllTasksUsersNotifications() {
    return this._http.get<any>(`${this._apiUrl}/taskNotificationForUser`).pipe(map((response) => response.result));
  }

  // ------------------------------------ CRM NOTIFICATIONS ------------------------------------

  getCrmNewsNotifications() {
    return this._http.get<any>(`${this._apiUrl}/get-crmnews-notification`).pipe(map((response) => response.result.news));
  }

  getCrmSurveyNotifications() {
    return this._http.get<any>(`${this._apiUrl}/get-crmsurvey-notification`).pipe(map((response) => response.result.survey));
  }

  getSurveyNotifications(userId: number) {
    return this._http.get<any>(`${this._apiUrl}/surveyNotify/${userId}`).pipe(map((response) => response.result));
  }

  readCrmNewsNotifications(newsIds: number[]) {
    return this._http.post<any>(`${this._apiUrl}/get-crmnews-read`, { newsIds });
  }

  readCrmSurveyNotifications(surveyIds: number[]) {
    return this._http.post<any>(`${this._apiUrl}/get-crmsurvey-read`, { surveyIds });
  }

  readSurveyNotifications(body: { id: number[]; loginId: number }) {
    return this._http.post<any>(`${this._apiUrl}/surveyread/`, body);
  }
}
